


























































import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  components: {}
})
export default class GanNanKeJi extends Vue {
  datalist3 = [
    {
      src: require("../../../assets/advisory1.png"),
      span1:
        "构建ICT人才生态黑土地 | 浙江华为助力南京工业职业技术学院在华为ICT大赛连创佳绩",
      names: "合作咨询"
    },
    {
      src: require("../../../assets/advisory2.png"),
      span1:
        "深化产教共融共建，推动校企共赢共进|全国高职院校华为ICT技术校企合作暨云与大数据专业建设研讨会顺利举行",
      names: "合作咨询"
    }
  ];
  setSelcted(index) {
    (this.$refs.carousel as any).setActiveItem(index);
  }
}
